import { NgModule } from "@angular/core";
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatDividerModule,
} from "@angular/material";
import {
  MatTableModule
} from "@angular/material/table"

@NgModule({
  imports: [
    MatCardModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatDividerModule
  ],
  exports: [
    MatCardModule,
    MatSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatDividerModule
  ],
})
export class MaterialModule {}



// WEBPACK FOOTER //
// ./src/app/shared/material.module.ts